import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewerComponent } from '../../../../../../shared/components/viewer/viewer.component';

@Component({
  selector: 'app-fotos',
  templateUrl: './fotos.component.html',
  styleUrls: ['./fotos.component.scss'],
})
export class CommunityPanelFotosComponent {
  galleryId = 'impact-trade-gallery';
  items: { src: string; thumb: string }[] = [];
  constructor(private modalService: NgbModal) {}

  ngOnInit() {
    this.items = [
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038520.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038549.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038571.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038590.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038607.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038625.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038646.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038665.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038684.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/1710806038700.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/storage-emulated-0-android-data-com-miui-gallery-cache-securityshare-1710806038497.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/foto-de-juan-ignacio-chama.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/impact-trade-2024-0315-130109-0518-albertobrescia-ph.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/impact-trade-2024-0315-151429-6865-albertobrescia-ph.webp',
        thumb: '',
      },
      {
        src: 'assets/img/imgs/impact-trade/galeria/impact-trade-2024-0315-152702-6931-albertobrescia-ph.webp',
        thumb: '',
      },
    ];
  }

  openModal(index: number) {
    const modalRef = this.modalService.open(ViewerComponent, {
      centered: true,
      size: 'xl',
      modalDialogClass: 'photo-viewer',
    });
    modalRef.componentInstance.index = index;
    modalRef.componentInstance.images = this.items;
  }
}
